import Recaptcha from 'react-google-recaptcha'
import React, { Component, Fragment } from 'react'
import { Dimmer, Loader, Segment } from 'semantic-ui-react/dist/commonjs'
import 'semantic-ui-css/components/dimmer.min.css'
import 'semantic-ui-css/components/loader.min.css'
import 'semantic-ui-css/components/segment.min.css'
import 'semantic-ui-css/components/message.min.css'
import Helmet from 'react-helmet'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { subscribePrint, updateForm, reinitialize } from '../../store/subscribePrint'

export class SubscribePrint extends Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.verifyCallback = this.verifyCallback.bind(this)
  }
  handleChange (event) {
    let newState = {}
    newState[event.target.name] = event.target.value
    this.props.updateForm(newState)
  }
  validateEmail (email) {
    var re = /^[^.@][^@]+@{1}[^@]+\.[^@]+[^.@]$/i
    return email.match(re)
  }
  validateName (name) {
    var re = /^[`a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ' -]{2,45}$/i
    return name.match(re)
  }
  validateFreeText (name) {
    var re = /^[`0-9a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ' -,]{2,45}$/i
    return name.match(re)
  }
  validatePhone (phone) {
    var re = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s.]{0,1}[0-9]{3}[-\s.]{0,1}[0-9]{4}$/
    return phone.match(re)
  }
  verifyCallback () {
    this.props.updateForm({ captchaVerified: true })
  }
  handleSubmit (event) {
    event.preventDefault()
    let errorNode = document.getElementsByClassName('form-error-validation')
    while (errorNode.length > 0) {
      errorNode[0].parentNode.removeChild(errorNode[0])
    }
    if (!this.validateName(this.props.firstName)) {
      let input = document.getElementById('firstName')
      input.insertAdjacentHTML('afterend', '<p class="form-error-validation" style="color:red"> Please enter a valid first name </p>')
      return false
    } else if (!this.validateName(this.props.surname)) {
      let input = document.getElementById('surname')
      input.insertAdjacentHTML('afterend', '<p class="form-error-validation" style="color:red"> Please enter a valid surname </p>')
      return false
    } else if (!this.validateEmail(this.props.email)) {
      let input = document.getElementById('surname')
      input.insertAdjacentHTML('afterend', '<p class="form-error-validation" style="color:red"> Please enter a valid email address </p>')
      return false
    } else if (!this.validatePhone(this.props.phone)) {
      let input = document.getElementById('phone')
      input.insertAdjacentHTML('afterend', '<p class="form-error-validation" style="color:red"> Please enter a valid cellphone number </p>')
      return false
    } else if (!this.validateFreeText(this.props.address)) {
      let input = document.getElementById('address')
      input.insertAdjacentHTML('afterend', '<p class="form-error-validation" style="color:red"> Please enter a valid Line 1 address </p>')
      return false
    } else if (!this.validateFreeText(this.props.address_2)) {
      let input = document.getElementById('address_2')
      input.insertAdjacentHTML('afterend', '<p class="form-error-validation" style="color:red"> Please enter a valid Line 2 address </p>')
      return false
    } else if (!this.validateName(this.props.city)) {
      let input = document.getElementById('city')
      input.insertAdjacentHTML('afterend', '<p class="form-error-validation" style="color:red"> Please enter a valid city </p>')
      return false
    } else if (!this.validateName(this.props.province)) {
      let input = document.getElementById('province')
      input.insertAdjacentHTML('afterend', '<p class="form-error-validation" style="color:red"> Please enter a valid province/state </p>')
      return false
    } else if (!this.validateFreeText(this.props.country)) {
      let input = document.getElementById('country')
      input.insertAdjacentHTML('afterend', '<p class="form-error-validation" style="color:red"> Please enter a valid country </p>')
      return false
    } else if (!this.props.captchaVerified) {
      let input = document.getElementById('captcha')
      input.insertAdjacentHTML('afterend', '<p class="form-error-validation" style="color:red"> Please enter a Captcha </p>')
      return false
    }
    this.props.subscribePrint(this.props)
    return true
  }

  componentWillMount () {
    this.props.reinitialize()
  }

  render () {
    if (!this.props.isFetching && !this.props.hasFetched) {
      return (
        <Fragment>
          <div className='wrapper static-page'>
            <Helmet title='Feedback, Enquiries and Comments | African Independent'>
              <meta name='description' content='We value your opinion. Feel free to send the African Independent team feedback on any of our stories, features and profiles by filling in our feedback form.' />
              <script src='https://www.google.com/recaptcha/api.js' async defer />
            </Helmet>
            <h1>Print Subscription Form</h1>
            <form id='item-form' name='item-form' encType='text/plain' onSubmit={this.handleSubmit}>
              <p>To subscribe to the African Independent print edition: Please fill out the form below.</p>
              <label htmlFor='firstName'>First Name:</label>
              <input id='firstName' placeholder='Type your first name' required='required' type='text' size='40' name='firstName' value={this.props.firstName} onChange={this.handleChange} />
              <label htmlFor='surname'>Surname:</label>
              <input id='surname' placeholder='Type your surname' required='required' type='text' size='40' name='surname' value={this.props.surname} onChange={this.handleChange} />
              <label htmlFor='email'>Email:</label>
              <input id='email' placeholder='example@domain.com' required='required' type='email' size='40' name='email' value={this.props.email ? this.props.email : ''} onChange={this.handleChange} />
              <label htmlFor='phone'>Contact Number:</label>
              <input id='phone' placeholder='+27812345678' required='required' type='text' size='40' name='phone' value={this.props.phone} onChange={this.handleChange} />
              <label htmlFor='address'>Address Line 1:</label>
              <input id='address' placeholder='' required='required' maxLength='255' type='text' size='40' name='address' value={this.props.address} onChange={this.handleChange} />
              <label htmlFor='address_2'>Address Line 2:</label>
              <input id='address_2' placeholder='' required='required' maxLength='255' type='text' size='40' name='address_2' value={this.props.address_2} onChange={this.handleChange} />
              <label htmlFor='city'>City:</label>
              <input id='city' placeholder='Type your city' required='required' maxLength='255' type='text' size='40' name='city' value={this.props.city} onChange={this.handleChange} />
              <label htmlFor='province'>Province/State:</label>
              <input name='province' id='province' placeholder='Type your province/state' required='required' maxLength='255' type='text' size='40' value={this.props.province} onChange={this.handleChange} />
              <label htmlFor='postal'>Postal/ZIP Code:</label>
              <input id='postal' placeholder='Type your postal/zip code (if applicable)' maxLength='10' type='text' size='40' name='postal' value={this.props.postal} onChange={this.handleChange} />
              <label htmlFor='country'>Country</label>
              <select name='country' id='country' onChange={this.handleChange}>
                <option value=''>Unknown</option>
                <option value='af'>Afghanistan</option>
                <option value='ax'>Aland Islands</option>
                <option value='al'>Albania</option>
                <option value='dz'>Algeria</option>
                <option value='as'>American Samoa</option>
                <option value='ad'>Andorra</option>
                <option value='ao'>Angola</option>
                <option value='ai'>Anguilla</option>
                <option value='aq'>Antarctica</option>
                <option value='ag'>Antigua and Barbuda</option>
                <option value='ar'>Argentina</option>
                <option value='am'>Armenia</option>
                <option value='aw'>Aruba</option>
                <option value='au'>Australia</option>
                <option value='at'>Austria</option>
                <option value='az'>Azerbaijan</option>
                <option value='bs'>Bahamas</option>
                <option value='bh'>Bahrain</option>
                <option value='bd'>Bangladesh</option>
                <option value='bb'>Barbados</option>
                <option value='by'>Belarus</option>
                <option value='be'>Belgium</option>
                <option value='bz'>Belize</option>
                <option value='bj'>Benin</option>
                <option value='bm'>Bermuda</option>
                <option value='bt'>Bhutan</option>
                <option value='bo'>Bolivia</option>
                <option value='ba'>Bosnia and Herzegovina</option>
                <option value='bw'>Botswana</option>
                <option value='bv'>Bouvet Island</option>
                <option value='br'>Brazil</option>
                <option value='io'>British Indian Ocean Territory</option>
                <option value='bn'>Brunei</option>
                <option value='bg'>Bulgaria</option>
                <option value='bf'>Burkina Faso</option>
                <option value='bi'>Burundi</option>
                <option value='kh'>Cambodia</option>
                <option value='cm'>Cameroon</option>
                <option value='ca'>Canada</option>
                <option value='cv'>Cape Verde</option>
                <option value='ky'>Cayman Islands</option>
                <option value='cf'>Central African Republic</option>
                <option value='td'>Chad (Tchad)</option>
                <option value='cl'>Chile</option>
                <option value='cn'>China</option>
                <option value='cx'>Christmas Island</option>
                <option value='cc'>Cocos Islands</option>
                <option value='co'>Colombia</option>
                <option value='km'>Comoros</option>
                <option value='cg'>Congo</option>
                <option value='cd'>Congo, Democratic Republic of the</option>
                <option value='ck'>Cook Islands</option>
                <option value='cr'>Costa Rica</option>
                <option value='hr'>Croatia</option>
                <option value='cu'>Cuba</option>
                <option value='cy'>Cyprus</option>
                <option value='cz'>Czech Republic</option>
                <option value='ci'>Cote d'Ivoire</option>
                <option value='dk'>Denmark</option>
                <option value='dj'>Djibouti</option>
                <option value='dm'>Dominica</option>
                <option value='do'>Dominican Republic</option>
                <option value='ec'>Ecuador</option>
                <option value='eg'>Egypt</option>
                <option value='sv'>El Salvador</option>
                <option value='gq'>Equatorial Guinea (Guinea Ecuatorial)</option>
                <option value='er'>Eritrea</option>
                <option value='ee'>Estonia</option>
                <option value='et'>Ethiopia</option>
                <option value='fk'>Falkland Islands</option>
                <option value='fo'>Faroe Islands</option>
                <option value='fj'>Fiji</option>
                <option value='fi'>Finland</option>
                <option value='fr'>France</option>
                <option value='gf'>French Guiana</option>
                <option value='pf'>French Polynesia</option>
                <option value='tf'>French Southern Territories</option>
                <option value='ga'>Gabon</option>
                <option value='gm'>Gambia</option>
                <option value='ge'>Georgia</option>
                <option value='de'>Germany</option>
                <option value='gh'>Ghana</option>
                <option value='gi'>Gibraltar</option>
                <option value='gr'>Greece</option>
                <option value='gl'>Greenland</option>
                <option value='gd'>Grenada</option>
                <option value='gp'>Guadeloupe</option>
                <option value='gu'>Guam</option>
                <option value='gt'>Guatemala</option>
                <option value='gg'>Guernsey</option>
                <option value='gn'>Guinea</option>
                <option value='gw'>Guinea-Bissau</option>
                <option value='gy'>Guyana</option>
                <option value='ht'>Haiti</option>
                <option value='hm'>Heard Island and McDonald Islands</option>
                <option value='hn'>Honduras</option>
                <option value='hk'>Hong Kong</option>
                <option value='hu'>Hungary</option>
                <option value='is'>Iceland</option>
                <option value='in'>India</option>
                <option value='id'>Indonesia</option>
                <option value='ir'>Iran</option>
                <option value='iq'>Iraq</option>
                <option value='ie'>Ireland</option>
                <option value='im'>Isle of Man</option>
                <option value='il'>Israel</option>
                <option value='it'>Italy</option>
                <option value='jm'>Jamaica</option>
                <option value='jp'>Japan</option>
                <option value='je'>Jersey</option>
                <option value='jo'>Jordan</option>
                <option value='kz'>Kazakhstan</option>
                <option value='ke'>Kenya</option>
                <option value='ki'>Kiribati</option>
                <option value='kw'>Kuwait</option>
                <option value='kg'>Kyrgyzstan</option>
                <option value='la'>Laos</option>
                <option value='lv'>Latvia</option>
                <option value='lb'>Lebanon</option>
                <option value='ls'>Lesotho</option>
                <option value='lr'>Liberia</option>
                <option value='ly'>Libya</option>
                <option value='li'>Liechtenstein</option>
                <option value='lt'>Lithuania</option>
                <option value='lu'>Luxembourg</option>
                <option value='mo'>Macao</option>
                <option value='mk'>Macedonia</option>
                <option value='mg'>Madagascar</option>
                <option value='mw'>Malawi</option>
                <option value='my'>Malaysia</option>
                <option value='mv'>Maldives</option>
                <option value='ml'>Mali</option>
                <option value='mt'>Malta</option>
                <option value='mh'>Marshall Islands</option>
                <option value='mq'>Martinique</option>
                <option value='mr'>Mauritania</option>
                <option value='mu'>Mauritius</option>
                <option value='yt'>Mayotte</option>
                <option value='mx'>Mexico</option>
                <option value='fm'>Micronesia</option>
                <option value='md'>Moldova</option>
                <option value='mc'>Monaco</option>
                <option value='mn'>Mongolia</option>
                <option value='me'>Montenegro</option>
                <option value='ms'>Montserrat</option>
                <option value='ma'>Morocco</option>
                <option value='mz'>Mozambique</option>
                <option value='mm'>Myanmar</option>
                <option value='na'>Namibia</option>
                <option value='nr'>Nauru</option>
                <option value='np'>Nepal</option>
                <option value='nl'>Netherlands</option>
                <option value='an'>Netherlands Antilles</option>
                <option value='nc'>New Caledonia</option>
                <option value='nz'>New Zealand</option>
                <option value='ni'>Nicaragua</option>
                <option value='ne'>Niger</option>
                <option value='ng'>Nigeria</option>
                <option value='nu'>Niue</option>
                <option value='nf'>Norfolk Island</option>
                <option value='kp'>North Korea</option>
                <option value='mp'>Northern Mariana Islands</option>
                <option value='no'>Norway</option>
                <option value='om'>Oman</option>
                <option value='pk'>Pakistan</option>
                <option value='pw'>Palau</option>
                <option value='ps'>Palestinian Territories</option>
                <option value='pa'>Panama</option>
                <option value='pg'>Papua New Guinea</option>
                <option value='py'>Paraguay</option>
                <option value='pe'>Peru</option>
                <option value='ph'>Philippines</option>
                <option value='pn'>Pitcairn</option>
                <option value='pl'>Poland</option>
                <option value='pt'>Portugal</option>
                <option value='pr'>Puerto Rico</option>
                <option value='qa'>Qatar</option>
                <option value='re'>Reunion</option>
                <option value='ro'>Romania</option>
                <option value='ru'>Russia</option>
                <option value='rw'>Rwanda</option>
                <option value='sh'>Saint Helena</option>
                <option value='kn'>Saint Kitts and Nevis</option>
                <option value='lc'>Saint Lucia</option>
                <option value='pm'>Saint Pierre and Miquelon</option>
                <option value='vc'>Saint Vincent and the Grenadines</option>
                <option value='ws'>Samoa</option>
                <option value='sm'>San Marino</option>
                <option value='sa'>Saudi Arabia</option>
                <option value='sn'>Senegal</option>
                <option value='rs'>Serbia</option>
                <option value='cs'>Serbia and Montenegro</option>
                <option value='sc'>Seychelles</option>
                <option value='sl'>Sierra Leone</option>
                <option value='sg'>Singapore</option>
                <option value='sk'>Slovakia</option>
                <option value='si'>Slovenia</option>
                <option value='sb'>Solomon Islands</option>
                <option value='so'>Somalia</option>
                <option value='za'>South Africa</option>
                <option value='gs'>South Georgia and the South Sandwich Islands</option>
                <option value='kr'>South Korea</option>
                <option value='es'>Spain</option>
                <option value='lk'>Sri Lanka</option>
                <option value='sd'>Sudan</option>
                <option value='sr'>Suriname</option>
                <option value='sj'>Svalbard and Jan Mayen</option>
                <option value='sz'>Swaziland</option>
                <option value='se'>Sweden</option>
                <option value='ch'>Switzerland</option>
                <option value='sy'>Syria</option>
                <option value='st'>São Tomé and Príncipe</option>
                <option value='tw'>Taiwan</option>
                <option value='tj'>Tajikistan</option>
                <option value='tz'>Tanzania</option>
                <option value='th'>Thailand</option>
                <option value='tl'>Timor-Leste</option>
                <option value='tg'>Togo</option>
                <option value='tk'>Tokelau</option>
                <option value='to'>Tonga</option>
                <option value='tt'>Trinidad and Tobago</option>
                <option value='tn'>Tunisia</option>
                <option value='tr'>Turkey</option>
                <option value='tm'>Turkmenistan</option>
                <option value='tc'>Turks and Caicos Islands</option>
                <option value='tv'>Tuvalu</option>
                <option value='ug'>Uganda</option>
                <option value='ua'>Ukraine</option>
                <option value='ae'>United Arab Emirates</option>
                <option value='gb'>United Kingdom</option>
                <option value='us'>United States</option>
                <option value='um'>United States minor outlying islands</option>
                <option value='uy'>Uruguay</option>
                <option value='uz'>Uzbekistan</option>
                <option value='vu'>Vanuatu</option>
                <option value='va'>Vatican City</option>
                <option value='ve'>Venezuela</option>
                <option value='vn'>Vietnam</option>
                <option value='vg'>Virgin Islands, British</option>
                <option value='vi'>Virgin Islands, U.S.</option>
                <option value='wf'>Wallis and Futuna</option>
                <option value='eh'>Western Sahara</option>
                <option value='ye'>Yemen</option>
                <option value='zm'>Zambia</option>
                <option value='zw'>Zimbabwe</option>
              </select>
              <Recaptcha sitekey='6LfsLz4cAAAAALqO3FpVjEBCqOp-wBHVF9qJXuWn' onChange={this.verifyCallback} id='captcha' />
              <input id='submitbutton' type='submit' value='Submit' className='red-btn' />
              <input type='hidden' name='form_hash' value='n1opdyilO0bEvwBq' id='form_hash' />
            </form>
          </div>
        </Fragment>
      )
    } else if (this.props.isFetching) {
      return (
        <Fragment>
          <Helmet title='Article' />
          <Segment>
            <Dimmer active>
              <Loader indeterminate size='large'>Submitting your request</Loader>
            </Dimmer>
          </Segment>
        </Fragment>
      )
    } else if (this.props.hasFetched) {
      return (
        <div className='wrapper static-page'>
          <Helmet title='Thank you for your subscription request' />
          <h1>Thank you for your subscription request</h1>
          <p>Thank you for your subscription request. We will get back to you shortly.</p>
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => (state.subscribePrint)
const mapDispatchToProps = (dispatch) => bindActionCreators({ subscribePrint, updateForm, reinitialize }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SubscribePrint)
